import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../../environments/environment";
import { Pagos } from "../../../domain/model/no-hospitalario/pagos/entity/pagos.model";
import { Recaudo } from "../../../domain/model/no-hospitalario/pagos/entity/recaudo.model";
import { PagosGateway } from "../../../domain/model/no-hospitalario/pagos/gateway/pagos-gateway";

@Injectable({
    providedIn: 'root'
})
export class PagosService extends PagosGateway {

    private readonly url: string;

    constructor(private http: HttpClient) {
        super();
        this.url = `${environment.apiBaseUrl}`;

    }


    consultarPagos(codigoTipoDocumento: string, numeroDocumento: string) {
        return this.http.get<Pagos>(`${this.url}/api_programacion-nh/listarRecaudos?idTipoDocumento=${codigoTipoDocumento}&identificacionPaciente=${numeroDocumento}`)
    }

    realizarPago(recaudo: Recaudo): Observable<Boolean> {
        return this.http.post<Boolean>(`${this.url}/api_programacion-nh/guardarRecaudo`, recaudo);
    }



}
